exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  width: 60px;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 10px; }\n\nbutton {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/playhead/playhead.component.scss
// module id = ../../../../../src/app/playhead/playhead.component.scss
// module chunks = main